import { useState } from 'react';
import { useOrganizationContext } from '../organization.context';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { MetricRecordsUploadWizard } from '../../components/upload-contexts/quality-metric';
import { FEATURES } from 'shared/constants/features.constants';
export default function UploadQualityMetrics() {
  const { organization } = useOrganizationContext();
  const [open, setOpen] = useState(false);

  // check if organization exists and feature is enabled
  if (!organization?.features?.includes(FEATURES.QUALITY_METRICS)) {
    return null;
  }

  const dialogDescription = organization?.name;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-48">Import quality metrics</Button>
      </DialogTrigger>
      <DialogContent className="h-4/5 min-w-[85%] flex flex-col">
        <DialogHeader className="space-y-0 mb-0">
          <DialogTitle>Import quality metrics</DialogTitle>
          <DialogDescription>{dialogDescription}</DialogDescription>
        </DialogHeader>
        <MetricRecordsUploadWizard />
      </DialogContent>
    </Dialog>
  );
}
